import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { DefaultTopLevelGroup, Status } from "../../common/constants";
import { listGroupsUrl } from "../../config";
import {
  buildGroupIdToHierarchyMap,
  getHierarchy,
  IHierarchyNode
} from "./util";
import api from "../../api";
import { getCookie } from "../../common/utils";
import { IGroupApi, IGroupListPayload } from "../../common/types/groupTypes";

const initialState: IGroupApi = {
  groups: [],
  groupIdToHierarchyMap: {},
  groupsHierarchy: [],
  status: Status.IDLE,
  error: null,
  isLoaded: false,
};

export const groupList: any = createAsyncThunk("listGroups", async (orgId?: string) => {
  try {
    const organizationId: string = orgId ? orgId : DefaultTopLevelGroup.ID;
    const groupId: string = orgId ? orgId : getCookie("groupId");
    const response = await api.get(listGroupsUrl + `?orgId=${organizationId}`);
    const groupIdToHierarchyMap: Record<string, string> = buildGroupIdToHierarchyMap(response.data.value);
    const groupsHierarchy: IHierarchyNode[] = getHierarchy(response.data.value, groupId);
    const groupListPayload: IGroupListPayload = {groups: response.data.value, groupIdToHierarchyMap: groupIdToHierarchyMap, groupsHierarchy: groupsHierarchy}
    return groupListPayload;
  } catch (error) {
    throw error;
  }
});

const groupSlice = createSlice({
  name: "listGroups",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(groupList.pending, (state) => {
        state.status = Status.PENDING;
      })
      .addCase(groupList.fulfilled, (state, action) => {
        state.status = Status.SUCCESS;
        state.groups = action.payload.groups;
        state.groupIdToHierarchyMap = action.payload.groupIdToHierarchyMap;
        state.groupsHierarchy = action.payload.groupsHierarchy;
        state.isLoaded = true;
      })
      .addCase(groupList.rejected, (state, action) => {
        state.status = Status.FAILED;
        state.error = action.error.message;
      })
  },
});

type Selector = {
  groupApi: ReturnType<
    typeof groupSlice.reducer
  >;
};

export const selector = (store: Selector) => store['groupApi'];

export const reducer = groupSlice.reducer;